import { LinearProgress } from "@mui/joy";
import "./BMXLinearPogressBar.scss";
import propTypes from "prop-types";

const BMXLinearPogressBar = ({
  value,
  thickness,
  color,
  borderColor,
  backgroundColor,
}) => {
  return (
    <div className="BMXLinearPogressBar">
      <LinearProgress
        determinate
        variant="solid"
        thickness={thickness ? thickness : 12}
        sx={{
          "--LinearProgress-progressThickness": "8px",
          "--LinearProgress-radius": "8px",
          "--LinearProgress-progressRadius": "6px",

          color: `${color ? color : "#19aa8d"}`,
          borderColor: `${borderColor ? borderColor : "#a7b1c2"}`,
          backgroundColor: `${backgroundColor ? backgroundColor : "#d9d9d9"}`,
          width: "100%",
        }}
        value={value}
      />
      <div style={{ marginTop: "4px" }}>
        <small className="bold">{value ? `${value}%` : "0%"}</small>
      </div>
    </div>
  );
};

BMXLinearPogressBar.prototype = {
  /**
   Props zawiera dane nazwę danych które będą w chipie
  */
  value: propTypes.string,
  /**
   Props zawiera rozmiar (wysokość)
  */
  thickness: propTypes.number,
  /**
   Props zawiera kolor
  */
  color: propTypes.string,
  /**
   Props zawiera borderColor
  */
  borderColor: propTypes.string,
  /**
   Props zawiera backgroundColor
  */
  backgroundColor: propTypes.string,
};

export default BMXLinearPogressBar;
